import * as React from 'react';
import { cn } from '@/lib/utils';
import { IconButton, IconButtonProps } from '@/components/ui/button';

interface ButtonGroupProps extends React.ComponentPropsWithRef<'div'> {
  value: unknown;
  onChange: (value: never) => void;
}

const ButtonGroup = ({ ref, className, value, onChange, children, ...props }: ButtonGroupProps) => {
  const processChild = (child: unknown): unknown => {
    if (React.isValidElement(child)) {
      if (child.type === ButtonGroupItem) {
        return React.cloneElement(child, {
          // @ts-expect-error - We know this is a ButtonGroupItem
          isSelected: child.props.value === value,
          // @ts-expect-error - We know this is a ButtonGroupItem
          onClick: () => onChange(child.props.value),
        });
      }
      // @ts-expect-error - We know this is a ButtonGroupItem
      if (child.props && child.props.children) {
        return React.cloneElement(child, {
          // @ts-expect-error - We know this is a ButtonGroupItem
          children: React.Children.map(child.props.children, processChild),
        });
      }
    }
    return child;
  };

  return (
    <div className={cn('flex flex-col gap-2', className)} {...props} ref={ref}>
      {/* @ts-expect-error - We know this is a ButtonGroup */}
      {React.Children.map(children, processChild)}
    </div>
  );
};

interface ButtonGroupItemProps extends IconButtonProps {
  isSelected?: boolean;
}

const ButtonGroupItem = ({ ref, className, isSelected, ...props }: ButtonGroupItemProps) => {
  return (
    <IconButton
      ref={ref}
      className={cn(
        'px-4 py-2 rounded-full border',
        isSelected ? 'bg-primary text-white' : 'bg-content-dark text-primary hover:bg-primary/40 hover:shadow-0',
        className,
      )}
      {...props}
    />
  );
};

export { ButtonGroup, ButtonGroupItem };
